import { LIST_WIDTH, ARCHIVED_COLUMN } from 'utils/constants/listview';

export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Company ID',
    field: 'businessClientId',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  {
    headerName: 'Company Name',
    field: 'name',
    width: LIST_WIDTH.xl,
  },
  {
    headerName: 'Contact Person',
    field: 'contactName',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  {
    headerName: 'Phone',
    field: 'contactPhone',
    width: LIST_WIDTH.PHONE_NUMBER,
  },
  { headerName: 'Email', field: 'email', width: LIST_WIDTH.xl },
  {
    headerName: 'Departments',
    field: 'departments',
    width: LIST_WIDTH.xl,
  },
];
